import { Theme } from '../stores/useThemeStore';
import { getThemeConfig, generateCSSCustomProperties } from './themeConfig';

// Remembered so the next call can clear the previous data-theme-<name> marker.
let appliedTheme: Theme | null = null;

export function applyThemeToDocument(theme: Theme): void {
  const themeConfig = getThemeConfig(theme);
  const properties = generateCSSCustomProperties(themeConfig);
  const documentElement = document.documentElement;

  if (appliedTheme) {
    documentElement.removeAttribute(`data-theme-${appliedTheme}`);
  }

  documentElement.setAttribute('data-theme', theme);
  documentElement.setAttribute(`data-theme-${theme}`, '');

  Object.entries(properties).forEach(([property, value]) => {
    documentElement.style.setProperty(property, value);
  });

  appliedTheme = theme;
}
